import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import './ProgressBar.css';

const ProgressBar = ({ progress, status, fileName }) => {
  return (
    <div className="progress-bar-container">
      <div className="progress-info">
        <span className="progress-label">{status}</span>
        <span className="progress-percentage">{progress}%</span>
      </div>
      {fileName && (
        <div className="progress-file-name">
          <span><FontAwesomeIcon icon={faFileLines} /> {fileName}</span>
        </div>
      )}
      <div className="progress-bar-track">
        <div 
          className="progress-bar-fill"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;
